import "../assets/css/community.css";
import chevron_downIcon from "../assets/img/modals/chevron-down.svg"
import chevron_down_greyIcon from "../assets/img/chevron-down-gray.svg"
import tickIcon from "../assets/img/tick.svg"
import addUserIcon from "../assets/img/add-user.svg"
import exportIcon from "../assets/img/export-icon.svg"
import dotsIcon from "../assets/img/dots.svg"
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { useEffect, useState } from "react";
import * as $ from "jquery"
import { ChevronRight } from "../utils/svg";
import PageHeader from "../components/page-header";
import Skeleton from "react-loading-skeleton";
import SideBar from "../components/side-bar";
import getAudience, { getDefaultAudience } from "../services/getAudience";
import { useSelector } from "react-redux";
import { apiUrl, pageUrl, protocol } from "../utils/url";
import { toast } from "react-toastify";
import { hideLoader, showLoader } from "../components/loader";
import { audiencePosts } from "../services/postRequests/audience";
import ImportModal from "../components/audience/import-modal";
import setDateFormat, { formatISODate } from "../utils/setDateFormat";
import CommunityFooter from "../components/community/footer";
import HeaderSearch from "../components/community/headerSearch";
import ConfirmationModal from "../components/confirmation-modal";
import NewSideBar from "../components/side-bar/new-sidebar";
import EmptyState from "./empty-state";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

let params = []
const Audience = () => {
    const [loading, setloading] = useState(true);
    const { slug , basePath } = useSelector(state => state?.slugReducer);
    const [allAudience, setallAudience] = useState([]);
    const [allDefaultAudience, setallDefaultAudience] = useState([]);
    const [confirmationModalShow, setconfirmationModalShow] = useState({ show: false, text: null, deleteAll: null});
    const [isConfirmMessage, setisConfirmMessage] = useState(false)
    const [showImportModal, setshowImportModal] = useState(false)
    const [selectAll, setSelectAll] = useState(false)
    const [selectedRows, setSelectedRows] = useState([]); 
    const customizeDomainsReducer = useSelector(state => state?.customizeDomainsReducer);
    const history = useHistory();
    const [filter, setfilter] = useState({
        page: 1,
        orderBy: null,
        filter: null,
        orderType: "asc"
    })

    $(document).on('click', '.filter-dropdown-menu li a', function () {
        $('.filter-dropdown-menu li a').removeClass('active');
        $(this).addClass('active');
        $('.filter-dropdown-menu-selected').text($(this).attr('data-value'));
    });

    // useEffect(() => {
    //     // showLoader()
    //     getDefaultAudience(slug).then((response) => {
    //         setloading(false)
    //         setallDefaultAudience(response);
    //         // hideLoader()
    //     })
    // }, [slug]);

    useEffect(() => {
        params = [];
        if (slug) {
            for (const key in filter) {
                if (Object.hasOwnProperty.call(filter, key)) {
                    if (filter[key])
                        params.push(`${[key]}=${filter[key]}`)
                }
            };
            if (filter?.page) callAudience()
        }
    }, [slug, filter]);

    const selectFilter = (e) => setfilter({ ...filter, filter: e.target.dataset?.value !== "All" ? e.target.dataset?.value?.toLowerCase() : null })
    const callAudience = () => {
        // showLoader()
        getAudience(slug, params?.join("&")).then((response) => {
            setloading(false);
            setallAudience(response);
            // hideLoader();
        })
    }

    const filterToggler = (e, value) => {
        setfilter({
            ...filter,
            "orderBy": !$(e.target).hasClass("sortable-col-desc") ? value : value,
            orderType: !$(e.target).hasClass("sortable-col-desc") ? "desc" : "asc"
        })

        if ($(e.target).hasClass('sortable-col-desc')) {
            $('.sortable-col').removeClass('sortable-col-desc');
        }
        else {
            $('.sortable-col').removeClass('sortable-col-desc');
            $(e.target).addClass('sortable-col-desc');
        }
    };

    const unsubscribeAudience = async (id) => {
        showLoader();
        const api = apiUrl + "/community/subscribers/unsubscribe";
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const form_data = new FormData();
        form_data.append("subscriber", id)
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: form_data
        }
        audiencePosts(api, hideLoader, setOptions).then(() => callAudience())
    };

    const deleteAudience = (id) => {
        // showLoader();
        const api = apiUrl + "/community/subscribers/delete/" + id;
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "DELETE",
            headers: myHeaders,
        }
        audiencePosts(api, hideLoader, setOptions).then(() => {
            setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
            callAudience()
        }).catch(() => {
                setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
                hideLoader()
            })
    }
    const copyEmail = (email) => navigator.clipboard.writeText(email).then((r => toast.success("Successfully Copied")))

    const openImportModal = () => setshowImportModal(true)
    const handleHide = () => setshowImportModal(false);
    const sendTocampaigns = () => {
        history.push(basePath + "/campaigns")
    }
    const exportCSV = () => {
        showLoader();
        const api = apiUrl + "/community/subscribers/export-csv";
        const formdata = new FormData();
        formdata.append("project", slug)
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: formdata
        }
        audiencePosts(api, hideLoader, setOptions, "export")
    }

    const deleteAllAudience = (ids) => {
        // showLoader();
        const api = apiUrl + "/community/subscribers/delete-all";
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        var formData = new FormData();
        formData.append('slug',slug);
        const inputs = document.querySelectorAll('input[name="select-one"]:checked');
        inputs.forEach(input => {
            formData.append("id[]", input.dataset.id);
        });
        const setOptions = {
            method: "POST",
            headers: myHeaders,
            body: formData,
        }
        audiencePosts(api, hideLoader, setOptions).then(() => {
            setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
            inputs.forEach(input => {
                input.checked = false;
            });
            const selectAllCheckbox = document.querySelector('input[name="select-all"]');
            if (selectAllCheckbox) {
                selectAllCheckbox.checked = false;
            }
            setSelectAll(false)
            setSelectedRows([]);
            callAudience()
        }).catch(() => {
                setconfirmationModalShow({ show: false, text: null, id: null, deleteAll: null })
                hideLoader()
            })
    }
    const landingUrl = (val) => {
        const domain = customizeDomainsReducer?.domain;
        const isCompanyName = val?.product?.domain_type === 'company_name';
        console.log("domain",domain)
        let link = domain ? (!domain?.includes('https://') ? 'https://'+domain : domain)+'/' : `${protocol + slug +'.'+ pageUrl}/`;
        link += isCompanyName ? val?.company_name_slug : val?.lead_slug;
        
        return link;
    };
    const copyLink = (val) => {
        const link = landingUrl(val);
        navigator.clipboard.writeText(link)
          .then(() => toast.success("Successfully Copied"))
          .catch(error => console.error('Error copying text: ', error));
    };
    const handleCheckboxChange = (e, id) => {
        if (id === 'select-all') {
            const inputs = document.querySelectorAll('input[name="select-one"]');
            inputs.forEach(input => {
                input.checked = e.target.checked;
                if (e.target.checked) {
                    setSelectedRows(selectedRows => [...selectedRows, input?.dataset?.id]);
                } else {
                    setSelectedRows([]);
                }
            });
        }  else {
            if (e.target.checked) {
                setSelectedRows([...selectedRows, id]);
            } else {
                const selectAllCheckbox = document.querySelector('input[name="select-all"]');
                if (selectAllCheckbox) {
                    selectAllCheckbox.checked = false;
                }
                const updatedSelectedRows = selectedRows.filter(rowId => rowId !== id);
                setSelectedRows(updatedSelectedRows);
            }
        }    
    };
    return (
        <div id="wrapper">
            <PageHeader />
            <div class="community-main new-sidebar">
                <NewSideBar from={"audience"}/>
                {/* <SideBar from="audience" /> */}

                <section class="community-section pb-0">

                    <div class="section-header sec-head-u">
                        <h1 class="mb-0">Leads  </h1>
                        <div class="d-md-flex d-none align-items-center justify-content-end">
                            <button class="project-blue-btn me-2" onClick={exportCSV}>
                                Download CSV
                            </button>
                            <HeaderSearch filter={filter} setfilter={setfilter} name="Leads" />

                            {/* <button class="btn btn-light btn-semi-rounded import-btn px-3 py-2 me-2 ms-2 d-flex align-items-center justify-content-center btn-import" onClick={openImportModal}>
                                <img src={addUserIcon} width="14px" alt="" />
                                <span>Import</span>
                            </button> */}
                        </div>
                    </div>
                    {!allAudience?.data?.length > 0?
                        <div class="section-main sec-main-u p-0 position-relative">
                            <EmptyState from={"audience"} firstText={'Import Leads From A Campaign'} secondText={"Create a campaign, and import leads to generate a custom landing page for each one."} clickedFunction={sendTocampaigns} buttonText={"Your Campaign's"}/>
                        </div>
                    :
                    <div class="section-main sec-main-u">
                      

                        <div class="d-flex table-responsive">
                            <table class="table" border="0">
                                <thead class="d-md-table-header-group dashview-u">
                                    <tr>                                        
                                        
                                        <th className={`aud-leftborder thead-padd aud-text ${selectAll ? ' selected':''}`}>
                                            {allAudience?.data?.length > 0 &&
                                            <label className="custom-checkbox checkbox">
                                                <input type="checkbox" name="select-all" data-id="select-all" onChange={(e) => handleCheckboxChange(e, 'select-all')}/>
                                                <span className="checkmark"></span>
                                            </label>
                                            }
                                            {selectedRows?.length > 0 ?
                                                <button className="delete-all-btn" onClick={() => setconfirmationModalShow({show: true, text: "Are you sure you want to delete lead?", id: selectedRows, callBackTo: "delete", deleteAll: true})}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
                                                        <path d="M8.77364 0.564453C9.54452 0.564453 10.1761 1.17108 10.2319 1.94053L10.2359 2.05151V3.53857H12.4293C12.8331 3.53857 13.1605 3.87146 13.1605 4.2821C13.1605 4.6634 12.8782 4.97767 12.5146 5.02062L12.4293 5.02562H12.3789L11.8418 12.6728C11.736 14.179 10.54 15.3569 9.07236 15.4313L8.92474 15.435H4.23572C2.75088 15.435 1.51038 14.3057 1.33282 12.8223L1.31862 12.6728L0.780849 5.02562H0.731137C0.327341 5.02562 0 4.69274 0 4.2821C0 3.90079 0.282235 3.58652 0.645858 3.54357L0.731137 3.53857H2.92455V2.05151C2.92455 1.26756 3.52104 0.625299 4.27767 0.568532L4.38682 0.564453H8.77364ZM10.9122 5.02562H2.24749L2.77719 12.5669C2.82639 13.2672 3.34705 13.8256 4.00996 13.9303L4.1217 13.9435L4.23572 13.948H8.92474C9.65355 13.948 10.2646 13.4038 10.3708 12.6822L10.3833 12.5669L10.9122 5.02562ZM5.11796 7.25621C5.49291 7.25621 5.80195 7.54324 5.84418 7.91303L5.84909 7.99974V10.9739C5.84909 11.3845 5.52175 11.7174 5.11796 11.7174C4.743 11.7174 4.43396 11.4304 4.39173 11.0606L4.38682 10.9739V7.99974C4.38682 7.5891 4.71416 7.25621 5.11796 7.25621ZM8.0425 7.25621C8.41745 7.25621 8.72649 7.54324 8.76873 7.91303L8.77364 7.99974V10.9739C8.77364 11.3845 8.4463 11.7174 8.0425 11.7174C7.66755 11.7174 7.35851 11.4304 7.31627 11.0606L7.31137 10.9739V7.99974C7.31137 7.5891 7.63871 7.25621 8.0425 7.25621ZM8.77364 2.05151H4.38682V3.53857H8.77364V2.05151Z" fill="#FF2020"/>
                                                    </svg>
                                                    <span>Delete </span>
                                                </button>
                                                :
                                                'Name'
                                            }
                                        </th>
                                        <th className={`thead-padd getwidth2 aud-text ${selectedRows?.length > 0 ? " invisible": ''}`}>Email Address</th>
                                        <th class={`thead-padd resp d-none-u ${selectedRows?.length > 0 ? " invisible": ''}`}>
                                            <span>
                                                Campaign
                                            </span>
                                        </th>
                                        {/* <th className={`thead-padd ${selectedRows?.length > 0 ? " invisible": ''}`}>
                                        </th>
                                        <th className={`th-end-u ${selectedRows?.length > 0 ? " invisible": ''}`}></th>  */}
                                    </tr>
                                </thead>

                                {
                                    loading ?
                                        <tbody>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                    <p class="mb-0 d-inline-flex align-items-center justify-content-start d-none">
                                                        <span class="subscriber-name-icon me-2 d-md-flex d-none">A</span>
                                                        <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                            <span class="d-none">Adam</span>
                                                            <Skeleton height={40}
                                                                borderRadius="10px"
                                                                className="d-md-none d-block"
                                                                highlightColor="#ffffff"
                                                                duration={4}
                                                            />
                                                        </span>
                                                    </p>
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <Skeleton height={40}
                                                        className="mb-1 me-2 mt-1 badge"
                                                        borderRadius="10px"
                                                        highlightColor="#ffffff"
                                                        duration={4}
                                                    />
                                                </td>
                                                <td class="d-md-table-cell d-none">

                                                    <div class="table-action-dropdown dropdown-toggle noselect d-flex align-items-center justify-content-end" id="table-action-dropdown" data-bs-toggle="dropdown" aria-expanded="false">

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        :
                                        <tbody>
                                            {
                                                allAudience?.data?.length > 0 && (
                                                    allAudience?.data?.map((val, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <label className="custom-checkbox checkbox">
                                                                    <input type="checkbox" name="select-one" data-id={val.id} onChange={(e) => handleCheckboxChange(e, val.id)}/>
                                                                    <span className="checkmark"></span>
                                                                </label>
                                                                <p class="mb-0 d-inline-flex align-items-center justify-content-start">
                                                                    <span class="subscriber-name-icon me-2 d-md-flex d-none">{val?.name.substring(0, 1).toUpperCase()}</span>
                                                                    <span class="d-flex align-items-start jusitfy-content-center flex-column">
                                                                        <span className="prodname">{val?.name}</span>
                                                                        {/* <span class="d-md-none d-block">{val?.email}</span> */}
                                                                    </span>
                                                                </p>
                                                            </td>
                                                            <td class="d-md-table-cell ps-0 prodname">{val?.email}</td>
                                                            {/* <td class="d-md-table-cell d-none thead-padd">{setDateFormat(val?.created_at)}</td> */}
                                                            <td class="d-md-table-cell ps-0 d-none prodname">
                                                                <div className="d-flex justify-content-start gap-12">
                                                                <div className="project-grey-btn border-radius-9">
                                                                    <span className="box-cyan"></span>
                                                                    <span> {val?.product?.name} </span>
                                                                </div>
                                                                <a href={landingUrl(val)} target="_blank" className="d-tab-none cursor-pointer border-radius-9 btn-fafafa">
                                                                    <span>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                                                            <rect x="10.3594" y="3.86816" width="1.348" height="10.11" rx="0.673998" transform="rotate(45 10.3594 3.86816)" fill="#1188FF"/>
                                                                            <rect x="11.4492" y="3.52637" width="1.38781" height="6.93906" rx="0.693906" transform="rotate(90 11.4492 3.52637)" fill="#1188FF"/>
                                                                            <rect width="1.38781" height="6.93906" rx="0.693906" transform="matrix(-1 0 0 1 11.5312 3.60938)" fill="#1188FF"/>
                                                                        </svg>
                                                                    </span>
                                                                    <span>
                                                                       <div className="text-decoration-none text-dark view-landing-page">
                                                                            View Landing Page
                                                                       </div>
                                                                    </span>
                                                                </a>
                                                                <div onClick={()=>copyLink(val)} className="btn-fafafa border-radius-9 cursor-pointer">
                                                                    <span className="box-18f">
                                                                    </span>
                                                                    <span>
                                                                       <div className="text-decoration-none text-dark">
                                                                            Copy Link
                                                                       </div>
                                                                    </span>
                                                                </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}

                                        </tbody>

                                }
                            </table>
                        </div>


                        <div class="section-footer d-flex align-items-center justify-content-between">
                            <CommunityFooter filter={filter} setfilter={setfilter} total={allAudience?.total} last_page={allAudience?.last_page} current_page={allAudience?.current_page}/>
                        </div>

                    </div>
                    }
                </section>
            </div>
            <ImportModal callAudience={callAudience} show={showImportModal} setshowImportModal={setshowImportModal} handleHide={handleHide} />
            {confirmationModalShow?.show && (
                <ConfirmationModal
                    confirmationModalShow={confirmationModalShow}
                    setShow={setconfirmationModalShow}
                    setisConfirmMessage={setisConfirmMessage}
                    callback={() => {
                        if (confirmationModalShow?.deleteAll) {
                            deleteAllAudience(confirmationModalShow?.id);
                        } else {
                            deleteAudience();
                        }
                    }}
                />
            )}
        </div>
    )
}
export default Audience